export default {"src":"/_next/static/media/kotakaful-deductibiles.9a12a4a9.svg","height":175,"width":250};